import { ApplicationConfig, ErrorHandler, importProvidersFrom, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { provideMsal } from './identity';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
// import { environment } from '@env/environment';

import { NgxsModule } from '@ngxs/store';
import { CommonDataState } from './shared/stores/common-data.state';

export function HttpLoaderFactory(httpClient: HttpClient) {
  
  // return isDevMode() ? new TranslateHttpLoader(httpClient) : new TranslateHttpLoader(httpClient, '/assets/i18n/', `-${environment.hash}.json`);
  return new TranslateHttpLoader(httpClient);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    importProvidersFrom(
      TranslateModule.forRoot({
        defaultLanguage: "en-US",
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
        }
      }),
      NgxsModule.forRoot([CommonDataState],
        {
          developmentMode: !environment.production,
          selectorOptions: {
            suppressErrors: false,
            injectContainerState: false
          }
        }
      ),
    ),
    
    provideHttpClient(withInterceptorsFromDi()),
    provideMsal(), provideAnimationsAsync()
  ]
};
